export default "__VITE_ASSET__Vr8sTucS__"